module.exports = __webpack_public_path__ + "img/86f870f9044df13413c59d99a484da28.ce319c51.png";